var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11010_1843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 0.0222939V33.9979H25.8377C25.8665 33.9987 25.8952 34 25.9243 34C27.4519 34 28.69 32.7619 28.69 31.2343L28.675 0L3.55469 0.0222939Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6895 30.3145C28.6848 31.838 27.4488 33.0714 25.9243 33.0714C25.8952 33.0714 25.8665 33.0701 25.8377 33.0693H3.55469V33.9984H25.8377C25.8665 33.9992 25.8952 34.0005 25.9243 34.0005C27.4519 34.0005 28.69 32.7624 28.69 31.2347L28.6895 30.3145Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55469 0.0107422H28.675V0.939827H3.55469V0.0107422Z",
    fill: "#EA82FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 4.34385L6.69183 0.87793L9.80157 4.34385L12.9543 0.87793L16.1069 4.34385L19.2594 0.87793L22.3694 4.34385L25.5221 0.87793L28.6746 4.34385V6.95613L25.5221 3.49046L22.3694 6.95613L19.2594 3.49046L16.1069 6.95613L12.9543 3.49046L9.80157 6.95613L6.69183 3.49046L3.53906 6.95613V4.34385Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80144 1.63427L11.2736 0.015625L8.35156 0.0182173L9.80144 1.63427Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00664 0.0205078L3.55469 0.0220632V1.61685L5.00664 0.0205078Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6328 0.0123579L16.1076 1.63385L17.5849 0.00976562L14.6328 0.0123579Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9102 0.00675781L22.3699 1.63369L23.8522 0.00390625L20.9102 0.00675781Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6743 1.63393V0L27.1895 0.00129615L28.6743 1.63393Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1914 0.00129615L28.0357 0.929603L28.6763 0.929085V0L27.1914 0.00129615Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7431 0.935065L23.0066 0.933769L23.8522 0.00390625L23.3884 0.00442471L20.9102 0.00675781L21.7431 0.935065Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5849 0.00976562L16.7471 0.0102841L14.6328 0.0123579L15.4771 0.940665L16.7391 0.939369L17.5849 0.00976562Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18473 0.946525L10.428 0.945488L11.2736 0.015625L10.5734 0.0161434L8.35156 0.0182173L9.18473 0.946525Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00664 0.0205078L3.55469 0.0220632V0.951148L4.16077 0.950371L5.00664 0.0205078Z",
    fill: "#D476E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 9.7042L6.69183 6.23828L9.80157 9.7042L12.9543 6.23828L16.1069 9.7042L19.2594 6.23828L22.3694 9.7042L25.5221 6.23828L28.6746 9.7042V12.3165L25.5221 8.85056L22.3694 12.3165L19.2594 8.85056L16.1069 12.3165L12.9543 8.85056L9.80157 12.3165L6.69183 8.85056L3.53906 12.3165V9.7042Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 15.0643L6.69183 11.5986L9.80157 15.0643L12.9543 11.5986L16.1069 15.0643L19.2594 11.5986L22.3694 15.0643L25.5221 11.5986L28.6746 15.0643V17.6768L25.5221 14.2109L22.3694 17.6768L19.2594 14.2109L16.1069 17.6768L12.9543 14.2109L9.80157 17.6768L6.69183 14.2109L3.53906 17.6768V15.0643Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 20.3253L6.69183 16.8594L9.80157 20.3253L12.9543 16.8594L16.1069 20.3253L19.2594 16.8594L22.3694 20.3253L25.5221 16.8594L28.6746 20.3253V22.9376L25.5221 19.4716L22.3694 22.9376L19.2594 19.4716L16.1069 22.9376L12.9543 19.4716L9.80157 22.9376L6.69183 19.4716L3.53906 22.9376V20.3253Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.53906 25.6847L6.69183 22.2188L9.80157 25.6847L12.9543 22.2188L16.1069 25.6847L19.2594 22.2188L22.3694 25.6847L25.5221 22.2188L28.6746 25.6847V28.2969L25.5221 24.831L22.3694 28.2969L19.2594 24.831L16.1069 28.2969L12.9543 24.831L9.80157 28.2969L6.69183 24.831L3.53906 28.2969V25.6847Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6752 31.5233V31.0079L25.5227 27.542L22.37 31.0077L19.26 27.542L16.1074 31.0077L12.9547 27.542L9.80216 31.0077L6.69216 27.542L3.55469 30.9911V33.6036L6.69216 30.1543L9.80216 33.6202L12.9547 30.1543L16.1074 33.6202L19.26 30.1543L22.37 33.6202L25.5227 30.1543L28.08 32.9656C28.4046 32.5623 28.619 32.0664 28.6752 31.5233Z",
    fill: "#C46DD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6751 31.0078L28.6139 30.9404C28.4685 31.5584 28.1172 32.0958 27.6348 32.4764L28.0796 32.9655C28.1206 32.9147 28.1597 32.8626 28.1968 32.809C28.2206 32.7748 28.2421 32.7392 28.2644 32.7042C28.2841 32.6729 28.3036 32.6412 28.3222 32.6091C28.3419 32.5749 28.3611 32.5399 28.3795 32.5049C28.4005 32.4645 28.42 32.423 28.4389 32.3815C28.4539 32.3488 28.4695 32.3164 28.483 32.2832C28.5094 32.2192 28.5333 32.1539 28.5548 32.0875C28.5641 32.059 28.5719 32.03 28.5802 32.0012C28.595 31.9494 28.6087 31.897 28.6206 31.8441C28.6268 31.8164 28.6333 31.7886 28.6388 31.7601C28.6538 31.6821 28.6665 31.6033 28.6751 31.5232V31.0078Z",
    fill: "#B665C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0214844 31.2325C0.0214844 32.7599 1.25983 33.9983 2.78748 33.9983H25.9247V33.9978C24.4035 33.9905 23.1724 32.7553 23.1724 31.2325C23.1724 29.7096 24.4035 28.4743 25.9247 28.4671V28.4668H2.78748C1.25983 28.4668 0.0214844 29.7051 0.0214844 31.2325Z",
    fill: "#EDD4C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9309 28.4668H25.9241V28.4671C24.403 28.4743 23.1719 29.7096 23.1719 31.2325C23.1719 31.8555 23.3803 32.4284 23.7277 32.8906H25.9309C27.1524 32.8906 28.1429 31.9003 28.1429 30.6786C28.1429 29.4571 27.1524 28.4668 25.9309 28.4668Z",
    fill: "#B665C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.39 31.3492C24.39 30.4984 24.9474 29.8086 25.7981 29.8086H23.5695C23.3186 30.2247 23.1719 30.7105 23.1719 31.232C23.1719 31.855 23.3803 32.4279 23.7277 32.8901H25.9309C25.0801 32.8901 24.39 32.2003 24.39 31.3492Z",
    fill: "#DBC4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7441 9.76172H32.1186V14.2902H16.7441V9.76172Z",
    fill: "#69EBFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7441 9.76172H32.1186V10.6908H16.7441V9.76172Z",
    fill: "#A1F1FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3296 18.3369H25.5332V16.2418C25.5332 16.022 25.7116 15.8436 25.9314 15.8436H33.1082V12.4233H32.1192V11.627H33.5064C33.7265 11.627 33.9046 11.805 33.9046 12.0251V16.2418C33.9046 16.4616 33.7265 16.64 33.5064 16.64H26.3296V18.3369Z",
    fill: "#5861C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9319 27.3659C25.3297 27.3659 24.8418 26.8781 24.8418 26.2761V18.5368C24.8418 18.4263 24.9315 18.3369 25.0419 18.3369H26.8218C26.9322 18.3369 27.0219 18.4263 27.0219 18.5368V26.2761C27.0217 26.8781 26.5335 27.3659 25.9319 27.3659Z",
    fill: "#6770E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8418 21.251V26.2764C24.8418 26.8784 25.3299 27.3665 25.9319 27.3665C26.5338 27.3665 27.0219 26.8784 27.0219 26.2764V21.251H24.8418Z",
    fill: "#5861C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9247 33.9979V33.9973C25.1089 33.9935 24.3783 33.6342 23.8747 33.0688H2.78722C1.41848 33.0688 0.284863 32.0733 0.0634799 30.7676V30.7678C0.0510368 30.8415 0.0409267 30.9161 0.0339275 30.991C0.0269283 31.0706 0.0214844 31.1507 0.0214844 31.2319C0.0214844 31.4229 0.0409267 31.6093 0.0777376 31.7895C0.114548 31.9694 0.168987 32.1431 0.238979 32.3084C0.483694 32.8876 0.920239 33.3659 1.46903 33.664C1.86099 33.8768 2.30998 33.9976 2.78722 33.9976H25.9247V33.9979Z",
    fill: "#DBC4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11010_1843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallpaper);
export default __webpack_public_path__ + "static/media/wallpaper.d277b8d80afeb32798dfe7bd9a419cf7.svg";
export { ForwardRef as ReactComponent };